import Dexie from 'dexie'
export const db = new Dexie('keeper')
db.version(3).stores({
  problem: '++id, projectId, companyId, problemType, problemTypeName, problemSubclass, problemDescription, problemLevel, problemLevelName, problemPhotoFiles, inspectionDate, suggestions, opportunity,specificProblem,dictFileCode,specificProblemName,dictFileCodeName',

  workRecords: '++id,projectId,cacheCode,companyId,signAddress,companyAlias,lng,lat,signTime,commonCheckUser,thisContact,contactPhone,companyAddress,industryName,productionStatus,isNightProduction,process,produced,' +
    'envPermitQuestionOneAnswer,' +
    'envPermitQuestionTwoAnswer,' +
    'envPermitQuestionThreeAnswer,' +
    'envPermitQuestionFourAnswer,' +
    'envPermitQuestionFiveAnswer,' +
    'envPermitQuestionSixAnswer,' +
    'envPermitQuestionSevenAnswer,' +
    'envPermitQuestionEightAnswer,' +
    'envPermitQuestionNineAnswer,' +
    'envPermitQuestionTenAnswer,' +
    'envPermitQuestionEleventhAnswer,' +
    'envPermitQuestionDecemberAnswer,' +
    'envPermitQuestionThirteenthAnswer,' +
    'envPermitQuestionFourteenthAnswer,' +
    'envPermitQuestionFifteenAnswer,' +
    'envPermitQuestionSixteenthAnswer,' +
    'envPermitQuestionSeventeenthAnswer,' +
    'envPermitQuestionEighteenAnswer,' +
    'envPermitQuestionNineteenthAnswer,' +
    'envPermitQuestionTwentyAnswer,' +
    'envPermitQuestionTwentyOneAnswer,' +
    'envPermitQuestionTwentyTwoAnswer,' +
    'envPermitQuestionTwentyThreeAnswer,' +
    'envPermitQuestionTwentyFourAnswer,' +
    'envPermitQuestionTwentyFiveAnswer,' +
    'potentialRisksQuestionOneAnswer,' +
    'potentialRisksQuestionTwoAnswer,' +
    'potentialRisksQuestionTwoAnswerNum,' +
    'potentialRisksQuestionThreeAnswer,' +
    'potentialRisksQuestionThreeAnswerNum,' +
    'potentialRisksQuestionFourAnswer,' +
    'potentialRisksQuestionFourAnswerNum,' +
    'potentialRisksQuestionFiveAnswer,' +
    'potentialRisksQuestionFiveAnswerNum,' +
    'potentialRisksQuestionSixAnswer,' +
    'potentialRisksQuestionSevenAnswer,' +
    'potentialRisksQuestionEightAnswer,' +
    'potentialRisksQuestionNineAnswer,' +
    'proWasteGasQuestionOneAnswer,' +
    'proWasteGasQuestionTwoAnswer,' +
    'proWasteGasQuestionThreeAnswer,' +
    'proWasteGasQuestionFourAnswer,' +
    'proWasteGasQuestionFiveAnswer,' +
    'proWasteGasQuestionSixAnswer,' +
    'proWasteGasQuestionSevenAnswer,' +
    'proWasteGasQuestionEightAnswer,' +
    'proWasteGasQuestionNineAnswer,' +
    'proWasteGasQuestionTenAnswer,' +
    'proWasteGasQuestionEleventhAnswer,' +
    'proWasteGasQuestionDecemberAnswer,' +
    'proWasteGasQuestionThirteenthAnswer,' +
    'proWasteGasQuestionFourteenthAnswer,' +
    'proWasteGasQuestionFifteenAnswer,' +
    'proWasteWaterQuestionOneAnswer,' +
    'proWasteWaterQuestionTwoAnswer,' +
    'proWasteWaterQuestionThreeAnswer,' +
    'proWasteWaterQuestionFourAnswer,' +
    'proWasteWaterQuestionFiveAnswer,' +
    'proWasteWaterQuestionSixAnswer,' +
    'proWasteWaterQuestionSevenAnswer,' +
    'proWasteWaterQuestionSevenAnswerOther,' +
    'proWasteWaterQuestionEightAnswer,' +
    'proWasteWaterQuestionNineAnswer,' +
    'proWasteWaterQuestionTenAnswer,' +
    'proWasteWaterQuestionEleventhAnswer,' +
    'proWasteWaterQuestionDecemberAnswer,' +
    'proWasteWaterQuestionThirteenthAnswer,' +
    'proWasteWaterQuestionFourteenthAnswer,' +
    'proWasteWaterQuestionFifteenAnswer,' +
    'proWasteWaterQuestionSixteenAnswer,' +
    'proWasteWaterQuestionSeventeenthAnswer,' +
    'chemSolidWasteQuestionOneAnswer,' +
    'chemSolidWasteQuestionTwoAnswer,' +
    'chemSolidWasteQuestionThreeAnswer,' +
    'chemSolidWasteQuestionFiveAnswer,' +
    'chemSolidWasteQuestionSixAnswer,' +
    'chemSolidWasteQuestionSevenAnswer,' +
    'chemSolidWasteQuestionEightAnswer,' +
    'chemSolidWasteQuestionFourAnswer,' +
    'chemSolidWasteQuestionNineAnswer,' +
    'chemSolidWasteQuestionTenAnswer,' +
    'chemSolidWasteQuestionEleventhAnswer,' +
    'chemSolidWasteQuestionDecemberAnswer,' +
    'chemSolidWasteQuestionThirteenthAnswer,' +
    'chemSolidWasteQuestionFourteenthAnswer,' +
    'chemSolidWasteQuestionFifteenAnswer,' +
    'chemSolidWasteQuestionSixteenAnswer,' +
    'chemSolidWasteQuestionSeventeenthAnswer,' +
    'chemSolidWasteQuestionEighteenAnswer,' +
    'chemSolidWasteQuestionNineteenthAnswer,' +
    'chemSolidWasteQuestionTwentyAnswer,' +
    'chemSolidWasteQuestionTwentyOneAnswer,' +
    'chemSolidWasteQuestionTwentyTwoAnswer,' +
    'chemSolidWasteQuestionTwentyTwoAnswerUnit,' +
    'chemSolidWasteQuestionTwentyThreeAnswer,' +
    'chemSolidWasteQuestionTwentyFourAnswer,' +
    'chemSolidWasteQuestionTwentyFiveAnswer,' +
    'chemSolidWasteQuestionTwentySixAnswer,' +
    'chemSolidWasteQuestionTwentySevenAnswer,' +
    'chemSolidWasteQuestionTwentyEightAnswer,' +
    'chemSolidWasteQuestionTwentyNineAnswer,' +
    'chemSolidWasteQuestionThirtyAnswer,' +
    'chemSolidWasteQuestionThirtyOneAnswer,' +
    'chemSolidWasteQuestionThirtyTwoAnswer,' +
    'chemSolidWasteQuestionThirtyThreeAnswer,' +
    'chemSolidWasteQuestionThirtyFourAnswer,' +
    'chemSolidWasteQuestionThirtyFiveAnswer,' +
    'chemSolidWasteQuestionThirtySixAnswer,' +
    'chemSolidWasteQuestionThirtySixAnswerGo,' +
    'chemSolidWasteQuestionThirtySevenAnswer,' +
    'soilGroundwaterQuestionOneAnswer,' +
    'soilGroundwaterQuestionTwoAnswer,' +
    'soilGroundwaterQuestionThreeAnswer,' +
    'soilGroundwaterQuestionFourAnswer,' +
    'selfMonitorQuestionOneAnswer,' +
    'selfMonitorQuestionTwoAnswer,' +
    'selfMonitorQuestionThreeAnswer,' +
    'selfMonitorQuestionFourAnswer,' +
    'onlineMonitorQuestionOneAnswer,' +
    'onlineMonitorQuestionTwoAnswer,' +
    'onlineMonitorQuestionThreeAnswer,' +
    'onlineMonitorQuestionFourAnswer,' +
    'onlineMonitorQuestionFiveAnswer,' +
    'onlineMonitorQuestionSixAnswer,' +
    'suddenEnvQuestionOneAnswer,' +
    'suddenEnvQuestionTwoAnswer,' +
    'suddenEnvQuestionThreeAnswer,' +
    'suddenEnvQuestionFourAnswer,' +
    'suddenEnvQuestionFiveAnswer,' +
    'suddenEnvQuestionSixAnswer,' +
    'suddenEnvQuestionSevenAnswer,' +
    'suddenEnvQuestionEightAnswer,' +
    'odsModuleQuestionOneAnswer,' +
    'odsModuleQuestionTwoAnswer,' +
    'odsModuleQuestionThreeAnswer,' +
    'odsModuleQuestionThreeAnswerOther,' +
    'odsModuleQuestionFourAnswer,' +
    'odsModuleQuestionFiveAnswer,' +
    'odsModuleQuestionSixAnswer,' +
    'boilerSaidQuestionOneAnswer,' +
    'boilerSaidQuestionTwoAnswer,' +
    'boilerSaidQuestionThreeAnswer,' +
    'boilerSaidQuestionFourAnswer,' +
    'boilerSaidQuestionFourAnswerOther,' +
    'boilerSaidQuestionFiveAnswer,' +
    'boilerSaidQuestionSixAnswer,' +
    'boilerSaidQuestionSixAnswerOther,' +
    'boilerSaidQuestionSevenAnswer,' +
    'boilerSaidQuestionSevenAnswerOther,' +
    'boilerSaidQuestionEightAnswer,' +
    'boilerSaidQuestionNineAnswer,' +
    'penaltyQuestionOneAnswer,' +
    'penaltyQuestionTwoAnswer,' +
    'penaltyQuestionThreeAnswer',
  workRecordCheckItemRemarks: '++id, remarks'
})
export const ProblemStore = db.problem
export const WorkRecordsStore = db.workRecords
export const WorkRecordCheckItemRemarksStore = db.workRecordCheckItemRemarks
